/**
 * Telegram Channel Management Page
 * Quản lý danh sách Telegram Bot đã kết nối
 */
import React, { Component } from 'react';
import { Modal, Button, Spin, Tooltip, notification, Switch, Pagination, Empty, Avatar } from 'antd';
import { fetchData } from '../../../lib/apis';
import { RobotOutlined, PlusOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import TelegramConnect from './TelegramConnect';

export default class TelegramChannel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            total: 0,
            loading: false,
            visibleConnect: false,
        };
        this.limit = 20;
        this.page = 1;
    }

    componentDidMount() {
        this.getListData();
    }

    getListData = async () => {
        try {
            this.setState({ loading: true });
            const params = new URLSearchParams({
                channel_type: 'telegram',
                limit: this.limit,
                page: this.page
            });

            let res = await fetchData({
                url: `api/v1/channel/list?${params.toString()}`
            });

            this.setState({
                listData: res.data || [],
                total: res.total || 0,
                loading: false
            });
        } catch (err) {
            this.setState({ loading: false });
            console.error('Error fetching Telegram channels:', err);
        }
    }

    deleteChannel = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc muốn xóa Bot Telegram này? Webhook sẽ ngừng hoạt động.',
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    await fetchData({
                        url: `api/v1/channel/delete/`,
                        method: 'delete',
                        data: { ids: [id] }
                    });
                    notification.success({
                        message: 'Thành công',
                        description: 'Đã xóa Bot Telegram'
                    });
                    this.getListData();
                } catch (err) {
                    notification.error({
                        message: 'Lỗi',
                        description: err.message || 'Không thể xóa tài khoản'
                    });
                }
            }
        });
    }

    enableChannel = async (id, enable) => {
        try {
            await fetchData({
                url: `api/v1/channel/enable`,
                method: 'post',
                data: { enable: enable ? 1 : 0, ids: [id] }
            });
            notification.success({
                message: 'Thành công',
                description: enable ? 'Đã bật kích hoạt' : 'Đã tắt kích hoạt'
            });
        } catch (err) {
            notification.error({
                message: 'Lỗi',
                description: err.message || 'Thao tác thất bại'
            });
        }
    }

    render() {
        const { listData, total, loading, visibleConnect } = this.state;
        const companyId = this.props.UserLogin?.company_id || this.props.companySelected?.company_id;

        return (
            <div className="list-connect content-m">
                <Modal
                    title={null}
                    visible={visibleConnect}
                    onCancel={() => this.setState({ visibleConnect: false })}
                    footer={null}
                    width={520}
                    destroyOnClose={true}
                >
                    <TelegramConnect 
                        companyId={companyId}
                        onSuccess={() => {
                            this.setState({ visibleConnect: false });
                            this.getListData();
                        }}
                        onCancel={() => this.setState({ visibleConnect: false })}
                    />
                </Modal>

                <div className="list-c">
                    <div style={{ marginBottom: "15px" }} className="table-header">
                        <h3>
                            <RobotOutlined style={{ marginRight: 8, color: '#0088cc' }} />
                            Quản lý Telegram Bot: {total}
                        </h3>
                        <div className="d-flex overflow-auto" style={{ marginBottom: "15px" }}>
                            <Button 
                                type="primary" 
                                icon={<PlusOutlined />}
                                style={{ background: '#0088cc', borderColor: '#0088cc', marginRight: 8 }}
                                onClick={() => this.setState({ visibleConnect: true })}
                            >
                                Kết nối Bot mới
                            </Button>
                            <Tooltip title="Làm mới">
                                <Button icon={<ReloadOutlined />} onClick={this.getListData} />
                            </Tooltip>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Pagination
                                total={total}
                                showSizeChanger
                                pageSize={this.limit}
                                pageSizeOptions={[20, 50, 100]}
                                current={this.page}
                                onChange={(current, size) => {
                                    this.page = current;
                                    this.limit = size;
                                    this.getListData();
                                }}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Spin spinning={loading}>
                            {listData.length > 0 ? (
                                <table className="table table-striped table-vcenter">
                                    <thead>
                                        <tr>
                                            <th>STT</th>
                                            <th>Ảnh</th>
                                            <th>Bot Username</th>
                                            <th>Tên Bot</th>
                                            <th>Trạng thái</th>
                                            <th>Kích hoạt</th>
                                            <th>Ngày kết nối</th>
                                            <th className="text-right">Hành động</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listData.map((item, i) => {
                                            const stt = this.limit * (this.page - 1) + (i + 1);
                                            return (
                                                <tr key={item._id}>
                                                    <td>{stt}</td>
                                                    <td>
                                                        <Avatar 
                                                            src={item.avatar} 
                                                            icon={<RobotOutlined />} 
                                                            style={{ backgroundColor: '#0088cc' }}
                                                        />
                                                    </td>
                                                    <td>@{item.username}</td>
                                                    <td>{item.full_name}</td>
                                                    <td>
                                                        <span className={`badge badge-${item.status == 1 ? 'success' : 'warning'}`}>
                                                            {item.status == 1 ? 'Đang chạy' : 'Mất kết nối'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Switch 
                                                            defaultChecked={item.enable == 1} 
                                                            onChange={(e) => this.enableChannel(item._id, e)}
                                                        />
                                                    </td>
                                                    <td>{moment(item.created_time).format('DD-MM-YYYY')}</td>
                                                    <td className="text-right">
                                                        <Tooltip title="Xóa">
                                                            <Button 
                                                                size="small" 
                                                                type="danger" 
                                                                icon={<DeleteOutlined />}
                                                                onClick={() => this.deleteChannel(item._id)}
                                                            />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <Empty 
                                    description="Chưa có Telegram Bot nào được kết nối"
                                    style={{ padding: 40 }}
                                >
                                    <Button 
                                        type="primary" 
                                        icon={<PlusOutlined />}
                                        style={{ background: '#0088cc', borderColor: '#0088cc' }}
                                        onClick={() => this.setState({ visibleConnect: true })}
                                    >
                                        Kết nối ngay
                                    </Button>
                                </Empty>
                            )}
                        </Spin>
                    </div>
                </div>
            </div>
        );
    }
}
